export default __webpack_public_path__ + "static/media/icon-ui-sauna.74c6b25f.svg";